import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "../lib/api";
import { FileText, Download } from "lucide-react";
import { fmtDate } from "../lib/format";

const CATEGORIES = { smlouva: "Smlouva o dílo", dodatek: "Dodatek", plna_moc: "Plná moc", pojisteni: "Pojištění", certifikat: "Certifikát", jine: "Jiné" };

export function JobDocuments({ jobId }) {
    const [items, setItems] = useState(null);
    useEffect(() => { api.get(`/documents?job_id=${jobId}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [jobId]);
    return (
        <div className="bg-white border border-slate-200" data-testid="job-documents">
            <div className="px-6 py-3 border-b-2 border-slate-900 flex items-center justify-between">
                <div className="font-display font-bold uppercase tracking-wider text-sm inline-flex items-center gap-2"><FileText className="w-4 h-4" /> Smlouvy a dokumenty zakázky</div>
                <Link to="/dokumenty" className="text-xs text-orange-700 hover:underline" data-testid="job-documents-link">Spravovat v Dokumentech</Link>
            </div>
            {!items ? <div className="p-6 text-sm text-slate-400">Načítání…</div> : items.length === 0 ? <div className="p-8 text-sm text-slate-400 text-center">K zakázce zatím není přiřazena žádná smlouva ani dokument (přiřadíte v sekci Dokumenty).</div> : items.map((d) => (
                <div key={d.id} className="flex items-center gap-3 px-6 py-3 border-b border-slate-100" data-testid={`job-document-${d.id}`}>
                    <div className="flex-1 min-w-0"><div className="font-medium text-slate-900 truncate">{d.name}</div><div className="text-xs text-slate-500">{CATEGORIES[d.category] || d.category}{d.client_name ? ` · ${d.client_name}` : ""}{d.expiry_date ? ` · platnost do ${fmtDate(d.expiry_date)}` : ""}</div></div>
                    {d.file_path && <a href={fileUrl(d.file_path)} target="_blank" rel="noreferrer" className="min-w-[40px] min-h-[40px] inline-flex items-center justify-center text-slate-500 hover:text-orange-600" title="Stáhnout"><Download className="w-4 h-4" /></a>}
                </div>
            ))}
        </div>
    );
}
